import { Component, OnInit } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {DialogModel} from '@shared/models/dialog.model';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';

@Component({
    standalone: false,
    selector: 'app-audit-case-archive-dialog',
  templateUrl: './audit-case-archive-dialog.component.html',
  styleUrls: ['./audit-case-archive-dialog.component.scss']
})
export class AuditCaseArchiveDialogComponent implements OnInit, IDialogView {
  constructor(private formBuilder: FormBuilder) { }
  inputForm: any;
  inputFormErrors: any;
  data: DialogModel;

  ngOnInit() {
    this.inputForm = this.formBuilder.group({
      comment : '',
    });
  }
  
  onOkClicked(): boolean {
    this.data.input['comment'] = this.inputForm.controls['comment'].value;
    return true;
  }
}
